import { useSelector, shallowEqual } from "react-redux";

export const selectHaasState = (state) => ({
    hasDaemon: Boolean(state.aiServiceDetails?.deployments?.daemon?.id),
    hasService: Boolean(state.aiServiceDetails?.deployments?.hostedService?.id),
    hasDaemonOrService: Boolean(
        state.aiServiceDetails?.deployments?.daemon?.id ||
        state.aiServiceDetails?.deployments?.hostedService?.id
    ),
});
/**
 * Something similar to "computed properties".
 */
export const useHaasSelector = () => {
    const result = useSelector(selectHaasState, shallowEqual);

    return result;
};

const selectProtoFileCount = (state) => (state.aiServiceDetails?.assets?.protoFiles.url ? 1 : 0);
export const useProtoFileCountSelector = () => {
    return useSelector(selectProtoFileCount);
};
